// added to datamodel utils
export const safeJSON = {
  parse: obstr => {
    let res = undefined;
    if (typeof obstr === 'string') {
      try {
        res = JSON.parse(obstr);
      } catch (e) {
        console.log('Err safeJSON caught parse error on probably not JSON string', obstr);
      }
    }
    return res;
  }
};